import selectInsurance from 'utils/selectInsurance';

const getInsuranceID = ({ patient, insurance, value, slice }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const selectedInsurance = insurance || selectInsurance(patient['Insurance Information']);
  if (slice !== undefined) {
    return selectedInsurance && selectedInsurance['Insurance ID'] ? selectedInsurance['Insurance ID'].slice(slice[0], slice[1]) : null;
  }
  return selectedInsurance ? selectedInsurance['Insurance ID'] : null;
};

export default getInsuranceID;



// WEBPACK FOOTER //
// ./src/utils/print/getInsuranceID.js